import { render, staticRenderFns } from "./o-list-practices.vue?vue&type=template&id=682f4b6c"
import script from "./o-list-practices.vue?vue&type=script&lang=js"
export * from "./o-list-practices.vue?vue&type=script&lang=js"
import style0 from "./o-list-practices.vue?vue&type=style&index=0&id=682f4b6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports